// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Includes inherited overrides from: core -> theme-stadium-house -> repli-training-stadium-house -> stadium-house-demo
// Generated: 2026-09-09T19:45:00.142Z
// Counts: 0 design, 56 content, 23 slot group, 0 collection binding, 5 section, 18 style

export const designOverrides = {};

export const contentOverrides = {
  "accessibility-hero.headline": {
    "overrideType": "VALUE",
    "customValue": "<h2>Accessible to everyone.</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "accessibility-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Accessibility</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitiesforyou.heading": {
    "overrideType": "VALUE",
    "customValue": "<h2>Amenities for you</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "apply-now-hero.blurb_heading": {
    "overrideType": "VALUE",
    "customValue": "<h2>Make it official</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "apply-now-hero.headline": {
    "overrideType": "VALUE",
    "customValue": "<h2>Your new home awaits.</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "apply-now-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Apply Now</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "audioeye-widget.cta_color": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_primary_color"
  },
  "contact-hero.blurb_heading": {
    "overrideType": "VALUE",
    "customValue": "<h2>Here to help.</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "contact-hero.headline": {
    "overrideType": "VALUE",
    "customValue": "<h2>We'd love to hear from you.</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "contact-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Contact Us</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "faq-hero.blurb_heading": {
    "overrideType": "VALUE",
    "customValue": "<h2>Frequently asked questions</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "floor-plans-hero.blurb_heading": {
    "overrideType": "VALUE",
    "customValue": "<h2>The comforts of home</h2><h2></h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "floor-plans-hero.headline": {
    "overrideType": "VALUE",
    "customValue": "<h2>Your perfect apartment is here.</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "floor-plans-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Floor Plans</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "floorplanslist.subtitle": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_home_floorplans_blurb"
  },
  "floorplanslist.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Spacious floor plans</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "footer.cta_banner_headline": {
    "overrideType": "VALUE",
    "customValue": "<h3>Live your best life at <span data-type=\"field-token\" data-field=\"property_name\"></span>.</h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "gallery-hero.blurb_heading": {
    "overrideType": "VALUE",
    "customValue": "<h2>Apartments designed for your lifestyle</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "gallery-hero.headline": {
    "overrideType": "VALUE",
    "customValue": "<h2>See yourself living here.</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "gallery-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Gallery</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>The Ultimate Student Living Experience</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "interactive-map-hero.blurb_heading": {
    "overrideType": "VALUE",
    "customValue": "<h2>Find your space</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "interactive-map-hero.headline": {
    "overrideType": "VALUE",
    "customValue": "<h2>Find your space.</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "interactive-map-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Interactive Map</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhood-hero.blurb_heading": {
    "overrideType": "VALUE",
    "customValue": "<h2>Discover Downtown Atlanta</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhood-hero.headline": {
    "overrideType": "VALUE",
    "customValue": "<h2>Explore what's around you.</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhood-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Neighborhood</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhoodsection.heading": {
    "overrideType": "VALUE",
    "customValue": "<h2>Perfect location</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "pet-policy-hero.blurb_heading": {
    "overrideType": "VALUE",
    "customValue": "<h2>Furry friends welcome</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "pet-policy-hero.headline": {
    "overrideType": "VALUE",
    "customValue": "<h2>Because pets are family too.</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "pet-policy-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Pet Policy</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "petpolicy.feature_1_title": {
    "overrideType": "VALUE",
    "customValue": "<h3>Pet spa</h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "petpolicy.feature_2_title": {
    "overrideType": "VALUE",
    "customValue": "<h3>Dog park</h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "petpolicy.feature_3_title": {
    "overrideType": "VALUE",
    "customValue": "<h3>Pet-friendly restaurants</h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "petpolicy.heading": {
    "overrideType": "VALUE",
    "customValue": "<h3>Pet policy</h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "privacy-policy-hero.headline": {
    "overrideType": "VALUE",
    "customValue": "<h2>Your privacy matters.</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "privacy-policy-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Privacy Policy</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "propertyoverview.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Embrace Life in Your Perfect Apartment Community Today</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "resident-access-hero.blurb_heading": {
    "overrideType": "VALUE",
    "customValue": "<h2>Everything at your fingertips</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "resident-access-hero.headline": {
    "overrideType": "VALUE",
    "customValue": "<h2>Welcome home.</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "resident-access-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Resident Access</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "residentreview.heading": {
    "overrideType": "VALUE",
    "customValue": "<h2>What residents say</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "reviews-hero.blurb_heading": {
    "overrideType": "VALUE",
    "customValue": "<h2>In their own words</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "reviews-hero.headline": {
    "overrideType": "VALUE",
    "customValue": "<h2>Hear it from our residents.</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "reviews-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Reviews</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "schedule-tour-hero.blurb_heading": {
    "overrideType": "VALUE",
    "customValue": "<h1>See it in person</h1><h2></h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "schedule-tour-hero.headline": {
    "overrideType": "VALUE",
    "customValue": "<h2>Come see it for yourself.</h2><h2></h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "schedule-tour-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Schedule A Tour</h1><h1></h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "sitemap-hero.headline": {
    "overrideType": "VALUE",
    "customValue": "<h2>Find your way around.</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "sitemap-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Sitemap</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "socialfeedsection.heading": {
    "overrideType": "VALUE",
    "customValue": "<h3>Follow us on social media</h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "thank-you-hero.headline": {
    "overrideType": "VALUE",
    "customValue": "<h2>Thanks for reaching out.</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "thank-you-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Thank You</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "virtual-tour-hero.blurb_heading": {
    "overrideType": "VALUE",
    "customValue": "<h2>360 views right here</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "virtual-tour-hero.headline": {
    "overrideType": "VALUE",
    "customValue": "<h2>Step inside from anywhere.</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "virtual-tour-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Virtual Tour</h1>",
    "generatedValue": null,
    "mappedField": null
  }
};

export const slotGroupOverrides = {
  "apply-now-hero.cta_link": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "FIELD_MAPPING",
        "mappedField": "property_apply_now_url"
      },
      "_target": {
        "type": "VALUE",
        "customValue": "_blank"
      },
      "label": {
        "type": "VALUE",
        "customValue": "Apply Now"
      }
    }
  },
  "floorplanslist.cta_link": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/floor-plans"
      }
    }
  },
  "amenitiesforyou.amenity_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "title": {
        "type": "GENERATOR",
        "generatedValue": "Rooftop Pool & Skyline Deck"
      }
    }
  },
  "amenitiesforyou.amenity_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "title": {
        "type": "GENERATOR",
        "generatedValue": "Sky Lounge with City Views"
      }
    }
  },
  "amenitiesforyou.amenity_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "title": {
        "type": "GENERATOR",
        "generatedValue": "24/7 Fitness Center"
      }
    }
  },
  "amenitiesforyou.amenity_4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "title": {
        "type": "GENERATOR",
        "generatedValue": "Study & Collaboration Rooms"
      }
    }
  },
  "amenitiesforyou.amenity_5": {
    "sourceIndex": null,
    "fieldOverrides": {
      "title": {
        "type": "GENERATOR",
        "generatedValue": "Fully Furnished Apartments"
      }
    }
  },
  "amenitiesforyou.amenity_6": {
    "sourceIndex": null,
    "fieldOverrides": {
      "title": {
        "type": "GENERATOR",
        "generatedValue": "Steps from Georgia Tech"
      }
    }
  },
  "amenitiesforyou.image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167722/01a020ae-130a-725f-9400-03984084df1b.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Cozy lounge area with pool table and ample seating."
      }
    }
  },
  "footer.cta_banner_background": {
    "sourceIndex": 1,
    "fieldOverrides": null
  },
  "footer.logo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "FIELD_MAPPING",
        "mappedField": "property_secondary_logo"
      },
      "alt": {
        "type": "FIELD_MAPPING",
        "mappedField": "property_secondary_logo_media.alt_text"
      }
    }
  },
  "header.logo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "FIELD_MAPPING",
        "mappedField": "property_primary_logo"
      },
      "alt": {
        "type": "FIELD_MAPPING",
        "mappedField": "property_primary_logo_media.alt_text"
      }
    }
  },
  "header.schedule_tour_link": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/contact-us"
      }
    }
  },
  "hero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167722/01a020ae-130a-725f-9400-03984084df1b.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Cozy lounge area with pool table and ample seating."
      }
    }
  },
  "hero.logo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "FIELD_MAPPING",
        "mappedField": "property_primary_logo"
      },
      "alt": {
        "type": "FIELD_MAPPING",
        "mappedField": "property_primary_logo_media.alt_text"
      }
    }
  },
  "propertyoverview.image_primary": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167722/01a020ae-1307-724b-a8d9-f198609cfc3a.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Modern kitchen with stainless steel appliances, light wood cabinets, and gray countertops."
      }
    }
  },
  "propertyoverview.image_secondary": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167722/01a020ae-1312-74d4-bca8-f82029d2cc3c.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Gym with weight machines, cardio equipment, and exposed brick walls."
      }
    }
  },
  "residentreview.image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167722/01a020ae-1307-724b-a8d9-f198609cfc3a.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Modern kitchen with stainless steel appliances, light wood cabinets, and gray countertops."
      }
    }
  },
  "socialfeedsection.photo_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167722/01a020a4-303e-70da-84b2-8e4441e401f3.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Modern lounge area with dark sofa, burgundy armchair, white oval coffee table, and city views."
      }
    }
  },
  "socialfeedsection.photo_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167722/01a020a4-27a2-77da-b97a-e02acfd6a97c.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Rooftop pool and lounge area with city skyline at dusk."
      }
    }
  },
  "socialfeedsection.photo_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167722/01a020a4-6b3a-7039-be0a-726b8abb40a0.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Midcity Lofts building exterior with signage and entrance."
      }
    }
  },
  "socialfeedsection.photo_4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167722/01a020a4-5877-704c-9c82-1f77fb332d33.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Street view of a modern apartment building with balconies and trees lining the sidewalk."
      }
    }
  },
  "socialfeedsection.photo_5": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167722/01a020a4-3556-720b-a12d-bed2835662cb.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Tall residential buildings with glass facades and balconies, overlooking a tree-lined street."
      }
    }
  }
};

export const collectionBindingOverrides = {};

export const sectionOverrides = {
  "_global": [
    {
      "sectionId": "apartment-sync-loader",
      "blockId": "apartment-sync-loader",
      "position": 0
    },
    {
      "sectionId": "audioeye-widget",
      "blockId": "audioeye-widget",
      "position": 0
    },
    {
      "sectionId": "google-tag-manager",
      "blockId": "google-tag-manager",
      "position": 0
    },
    {
      "sectionId": "json-ld-schema",
      "blockId": "json-ld-schema",
      "position": 0
    },
    {
      "sectionId": "multihub-lead-capture",
      "blockId": "multihub-lead-capture",
      "position": 0
    }
  ]
};

export const styleOverrides = {
  "_section.Footer": {
    "properties": {
      "color": "#283990"
    }
  },
  "amenities-hero.blurb_heading": {
    "properties": {
      "color": "#283990"
    }
  },
  "apply-now-hero.blurb_heading": {
    "properties": {
      "color": "#283990"
    }
  },
  "contact-hero.blurb_heading": {
    "properties": {
      "color": "#283990"
    }
  },
  "faq-hero.blurb_heading": {
    "properties": {
      "color": "#283990"
    }
  },
  "floor-plans-hero.blurb_heading": {
    "properties": {
      "color": "#283990"
    }
  },
  "footer.contact_label": {
    "properties": {
      "color": "#283990"
    }
  },
  "footer.hours_label": {
    "properties": {
      "color": "#283990"
    }
  },
  "footer.phone_link": {
    "properties": {
      "color": "#283990"
    }
  },
  "footer.residents_label": {
    "properties": {
      "color": "#283990"
    }
  },
  "footer.visit_label": {
    "properties": {
      "color": "#283990"
    }
  },
  "gallery-hero.blurb_heading": {
    "properties": {
      "color": "#283990"
    }
  },
  "neighborhood-hero.blurb_heading": {
    "properties": {
      "color": "#283990"
    }
  },
  "pet-policy-hero.blurb_heading": {
    "properties": {
      "color": "#283990"
    }
  },
  "petpolicycallout.description": {
    "properties": {
      "textAlign": "left"
    }
  },
  "petpolicycallout.heading": {
    "properties": {
      "textAlign": "left"
    }
  },
  "resident-access-hero.blurb_heading": {
    "properties": {
      "color": "#283990"
    }
  },
  "schedule-tour-hero.blurb_heading": {
    "properties": {
      "color": "#283990"
    }
  }
};
